import { numberFormat } from './numbers'

export const monthNames = [
  '',
  'Januar',
  'Februar',
  'Mars',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Desember',
]

export const SEC = 1000
export const MIN = SEC * 60
export const HOUR = MIN * 60
export const DAY = HOUR * 24
export const WEEK = DAY * 7

export function dateToMonth(dateString) {
  var parts = dateString.split('T')
  var dateParts = parts[0].split('-')
  var year = dateParts[0]
  var month = parseInt(dateParts[1])
  return monthNames[month] + ' ' + year
}

export function dateToMonthName(dateString) {
  var parts = dateString.split('T')
  var dateParts = parts[0].split('-')
  var month = parseInt(dateParts[1])
  return monthNames[month]
}

export function secondsToHours(seconds) {
  var hours = Math.floor(seconds / 3600)
  var minutes = Math.floor((seconds - hours * 3600) / 60)
  var secs = seconds % 60
  if (hours < 10) hours = '0' + hours
  if (minutes < 10) minutes = '0' + minutes
  if (secs < 10) secs = '0' + secs
  return hours + ':' + minutes + ':' + secs
}

export function byteFormatter(bytes) {
  var KB = bytes / 1024
  var MB = KB / 1024
  var GB = MB / 1024
  if (GB > 0.5) {
    return numberFormat(GB, 2) + ' GB'
  } else if (MB > 0.5) {
    return numberFormat(MB, 2) + ' MB'
  } else {
    return numberFormat(KB, 2) + ' KB'
  }
}

export function pad(n) {
  return n < 10 ? '0' + n : n
}
